import type { IParticipant } from '@/api/endpoints/schools/schoolParticipants';
import type { IPaginationSettings } from '@/api/types';

/**
 * Статус студента
 */
export enum EEnrolledSectionParticipantStatus {
  Accepted = 'accepted',
  Expelled = 'expelled',
}

export type TEnrolledSectionParticipant = Omit<IParticipant, 'status'> & {
  status: EEnrolledSectionParticipantStatus;
};

export interface IEnrolledSectionStats {
  total: number;
  accepted: number;
  expelled: number;
}

export interface IEnrolledSectionParticipantsResponse {
  data: TEnrolledSectionParticipant[];
  meta: {
    pagination: IPaginationSettings;
    stats: IEnrolledSectionStats;
  };
}

export interface IFormData {
  expulsionReason: string;
  expelledAt: Date;
}
